import SuiVue from 'semantic-ui-vue';
import Vue from 'vue';
import VueRx from 'vue-rx';
import VueTheMask from 'vue-the-mask';
import Vuelidate from 'vuelidate';
import VueMoney from 'v-money';

Vue.use(VueMoney, { precision: 2 });
Vue.use(SuiVue);
Vue.use(VueRx);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
